import { useEffect, ReactElement } from 'react';

export function CypressHydrationProvider({ children }: { children: ReactElement }) {
    useEffect(() => {
        globalThis.cypressHydrated = true;
    });
    return <>{children}</>;
}
